var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMedium18Dp = function SvgMedium18Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89091 9C9.89091 11.2092 8.12449 13 5.94545 13C3.76642 13 2 11.2092 2 9C2 6.79084 3.76642 5 5.94545 5C8.12449 5 9.89091 6.79084 9.89091 9",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2818 9.06454C14.2818 11.1846 13.3843 12.9032 12.2773 12.9032C11.1702 12.9032 10.2727 11.1846 10.2727 9.06454C10.2727 6.94448 11.1702 5.22583 12.2773 5.22583C13.3843 5.22583 14.2818 6.94448 14.2818 9.06454",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.96776C16 10.8918 15.6723 12.4516 15.2682 12.4516C14.864 12.4516 14.5364 10.8918 14.5364 8.96776C14.5364 7.04369 14.864 5.48389 15.2682 5.48389C15.6723 5.48389 16 7.04369 16 8.96776",
    fill: "currentColor"
  }))));
};

export { SvgMedium18Dp as ReactComponent };
export default __webpack_public_path__ + "7cd624e359becb021f7cebec93c1055b.svg";